"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugUI = void 0;
var vue_1 = require("vue");
var Card_1 = require("./card/Card");
var AllCards_1 = require("../cards/AllCards");
var GameModule_1 = require("../GameModule");
var ICardRenderDescription_1 = require("../cards/render/ICardRenderDescription");
var PreferencesManager_1 = require("./PreferencesManager");
var cards = new Map();
AllCards_1.ALL_CARD_MANIFESTS.forEach(function (manifest) {
    var module = manifest.module;
    [
        manifest.projectCards,
        manifest.corporationCards,
        manifest.preludeCards,
        manifest.standardProjects
    ].forEach(function (deck) {
        deck.factories.forEach(function (cf) {
            var card = new cf.Factory();
            var cardNumber = card.metadata.cardNumber;
            cards.set(card.name, { card: card, module: module, cardNumber: cardNumber });
        });
    });
});
exports.DebugUI = vue_1.default.component('debug-ui', {
    components: {
        Card: Card_1.Card,
    },
    data: function () {
        return {
            filterText: '',
            filterDescription: false,
            sortById: false,
            base: true,
            corporateEra: true,
            prelude: true,
            venusNext: true,
            colonies: true,
            turmoil: true,
            community: true,
            ares: true,
            moon: true,
            promo: true,
            rebalanced: true,
            league: true,
        };
    },
    mounted: function () {
        var urlParams = new URLSearchParams(window.location.search);
        var searchString = urlParams.get('search');
        if (searchString) {
            this.filterText = searchString;
        }
    },
    watch: {
        filterText: function (newSearchString) {
            if (window.history.pushState) {
                var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?search=' + newSearchString;
                window.history.pushState({ path: newurl }, '', newurl);
            }
        },
    },
    methods: {
        toggleAll: function () {
            var data = this.$data;
            data.base = !data.base;
            data.corporateEra = !data.corporateEra;
            data.prelude = !data.prelude;
            data.venusNext = !data.venusNext;
            data.colonies = !data.colonies;
            data.turmoil = !data.turmoil;
            data.community = !data.community;
            data.promo = !data.promo;
            data.ares = !data.ares;
            data.moon = !data.moon;
            data.rebalanced = !data.rebalanced;
            data.league = !data.league;
        },
        sort: function (names) {
            if (this.$data.sortById) {
                return names.sort(function (a, b) {
                    var _a, _b;
                    var an = ((_a = cards.get(a)) === null || _a === void 0 ? void 0 : _a.cardNumber) || '';
                    var bn = ((_b = cards.get(b)) === null || _b === void 0 ? void 0 : _b.cardNumber) || '';
                    return an.localeCompare(bn);
                });
            }
            else {
                return names.sort();
            }
        },
        getAllStandardProjectCards: function () {
            return this.sort(AllCards_1.ALL_STANDARD_PROJECT_CARD_NAMES);
        },
        getAllProjectCards: function () {
            return this.sort(AllCards_1.ALL_PROJECT_CARD_NAMES);
        },
        getAllCorporationCards: function () {
            return this.sort(AllCards_1.ALL_CORPORATION_CARD_NAMES);
        },
        getAllPreludeCards: function () {
            return this.sort(AllCards_1.ALL_PRELUDE_CARD_NAMES);
        },
        filtered: function (cardName) {
            var _a;
            var card = cards.get(cardName);
            var filterText = this.$data.filterText.toUpperCase();
            if (this.$data.filterText.length > 0) {
                if (cardName.toUpperCase().includes(filterText) === false) {
                    if (this.$data.filterDescription) {
                        var desc = (_a = card === null || card === void 0 ? void 0 : card.card.metadata) === null || _a === void 0 ? void 0 : _a.description;
                        if (ICardRenderDescription_1.isIDescription(desc)) {
                            desc = desc.text;
                        }
                        if (desc === undefined || desc.toUpperCase().includes(filterText) === false) {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                }
            }
            switch (card === null || card === void 0 ? void 0 : card.module) {
                case GameModule_1.GameModule.Base:
                    return this.base === true;
                case GameModule_1.GameModule.CorpEra:
                    return this.corporateEra === true;
                case GameModule_1.GameModule.Promo:
                    return this.promo === true;
                case GameModule_1.GameModule.Venus:
                    return this.venusNext === true;
                case GameModule_1.GameModule.Colonies:
                    return this.colonies === true;
                case GameModule_1.GameModule.Prelude:
                    return this.prelude === true;
                case GameModule_1.GameModule.Turmoil:
                    return this.turmoil === true;
                case GameModule_1.GameModule.Community:
                    return this.community === true;
                case GameModule_1.GameModule.Ares:
                    return this.ares === true;
                case GameModule_1.GameModule.Moon:
                    return this.moon === true;
                case GameModule_1.GameModule.Rebalanced:
                    return this.rebalanced === true;
                case GameModule_1.GameModule.League:
                    return this.league === true;
                default:
                    return true;
            }
        },
        getLanguageCssClass: function () {
            var language = PreferencesManager_1.PreferencesManager.load('lang') || 'en';
            return 'language-' + language;
        },
    },
    template: "\n        <div class=\"debug-ui-container\" :class=\"getLanguageCssClass()\">\n            <h1>Cards List</h1>\n            <div class=\"legacy-anchor\">\n              <a href=\"https://ssimeonoff.github.io/cards-list\" target=\"_blank\">legacy card UI</a>\n            </div>\n            <div class=\"form-group\">\n              <input class=\"form-input form-input-line\" placeholder=\"filter\" v-model=\"filterText\">\n              <input type=\"checkbox\" name=\"filterDescription\" id=\"filterDescription-checkbox\" v-model=\"filterDescription\">\n              <label for=\"filterDescription-checkbox\">\n                  <span v-i18n>Filter description</span>\n              </label>\n              <input type=\"checkbox\" name=\"sortById\" id=\"sortById-checkbox\" v-model=\"sortById\">\n              <label for=\"sortById-checkbox\">\n                  <span v-i18n>Sort by ID (work in progress)</span>\n              </label>\n            </div>\n\n            <div class=\"create-game-page-column\" style = \"flex-flow: inherit; \">\n            <button id=\"toggle-checkbox\" v-on:click=\"toggleAll()\">\n                <span v-i18n>Toggle all</span>\n            </button>\n\n            <input type=\"checkbox\" name=\"base\" id=\"base-checkbox\" v-model=\"base\">\n              <label for=\"base-checkbox\" class=\"expansion-button\">\n                  <span v-i18n>Base</span>\n              </label>\n\n              <input type=\"checkbox\" name=\"corporateEra\" id=\"corporateEra-checkbox\" v-model=\"corporateEra\">\n              <label for=\"corporateEra-checkbox\" class=\"expansion-button\">\n                  <div class=\"create-game-expansion-icon expansion-icon-CE\"></div>\n                  <span v-i18n>Corporate Era</span>\n              </label>\n\n              <input type=\"checkbox\" name=\"prelude\" id=\"prelude-checkbox\" v-model=\"prelude\">\n              <label for=\"prelude-checkbox\" class=\"expansion-button\">\n                  <div class=\"create-game-expansion-icon expansion-icon-prelude\"></div>\n                  <span v-i18n>Prelude</span>\n              </label>\n\n              <input type=\"checkbox\" name=\"venusNext\" id=\"venusNext-checkbox\" v-model=\"venusNext\">\n              <label for=\"venusNext-checkbox\" class=\"expansion-button\">\n              <div class=\"create-game-expansion-icon expansion-icon-venus\"></div>\n                  <span v-i18n>Venus Next</span>\n              </label>\n\n              <input type=\"checkbox\" name=\"colonies\" id=\"colonies-checkbox\" v-model=\"colonies\">\n              <label for=\"colonies-checkbox\" class=\"expansion-button\">\n              <div class=\"create-game-expansion-icon expansion-icon-colony\"></div>\n                  <span v-i18n>Colonies</span>\n              </label>\n\n              <input type=\"checkbox\" name=\"turmoil\" id=\"turmoil-checkbox\" v-model=\"turmoil\">\n              <label for=\"turmoil-checkbox\" class=\"expansion-button\">\n                  <div class=\"create-game-expansion-icon expansion-icon-turmoil\"></div>\n                  <span v-i18n>Turmoil</span>\n              </label>\n\n              <input type=\"checkbox\" name=\"promo\" id=\"promo-checkbox\" v-model=\"promo\">\n              <label for=\"promo-checkbox\" class=\"expansion-button\">\n                  <div class=\"create-game-expansion-icon expansion-icon-promo\"></div>\n                  <span v-i18n>Promos</span>\n              </label>\n\n              <input type=\"checkbox\" name=\"ares\" id=\"ares-checkbox\" v-model=\"ares\">\n              <label for=\"ares-checkbox\" class=\"expansion-button\">\n                  <div class=\"create-game-expansion-icon expansion-icon-ares\"></div>\n                  <span v-i18n>Ares</span>\n              </label>\n\n              <input type=\"checkbox\" name=\"community\" id=\"community-checkbox\" v-model=\"community\">\n              <label for=\"community-checkbox\" class=\"expansion-button\">\n                  <div class=\"create-game-expansion-icon expansion-icon-community\"></div>\n                  <span v-i18n>Community</span>\n              </label><span/>\n\n              <input type=\"checkbox\" name=\"moon\" id=\"moon-checkbox\" v-model=\"moon\">\n              <label for=\"moon-checkbox\" class=\"expansion-button\">\n                <div class=\"create-game-expansion-icon expansion-icon-themoon\"></div>\n                <span v-i18n>The Moon</span>\n              </label><span/>\n\n              <input type=\"checkbox\" name=\"rebalanced\" id=\"rebalanced-checkbox\" v-model=\"rebalanced\">\n              <label for=\"rebalanced-checkbox\" class=\"expansion-button\">\n                <div class=\"create-game-expansion-icon expansion-icon-rebalanced\"></div>\n                <span v-i18n>Rebalanced</span>\n              </label><span/>\n\n              <input type=\"checkbox\" name=\"league\" id=\"league-checkbox\" v-model=\"league\">\n              <label for=\"league-checkbox\" class=\"expansion-button\">\n                <div class=\"create-game-expansion-icon expansion-icon-league\"></div>\n                <span v-i18n>League</span>\n              </label><span/>\n            </div>\n\n            <section class=\"debug-ui-cards-list\">\n                <h2>Project Cards</h2>\n                <div class=\"cardbox\" v-for=\"card in getAllProjectCards()\">\n                    <Card v-show=\"filtered(card)\" :card=\"{'name': card}\" />\n                </div>\n            </section>\n            <br>\n            <section class=\"debug-ui-cards-list\">\n                <h2>Corporations</h2>\n                <div class=\"cardbox\" v-for=\"card in getAllCorporationCards()\">\n                    <Card v-show=\"filtered(card)\" :card=\"{'name': card}\" />\n                </div>\n            </section>\n            <br>\n            <section class=\"debug-ui-cards-list\">\n                <h2>Preludes</h2>\n                <div class=\"cardbox\" v-for=\"card in getAllPreludeCards()\">\n                    <Card v-show=\"filtered(card)\" :card=\"{'name': card}\" />\n                </div>\n            </section>\n            <br>\n            <section class=\"debug-ui-cards-list\">\n              <h2>Standard Projects</h2>\n              <div class=\"cardbox\" v-for=\"card in getAllStandardProjectCards()\">\n                  <Card v-show=\"filtered(card)\" :card=\"{'name': card}\" />\n              </div>\n            </section>\n        </div>\n    ",
});
//# sourceMappingURL=DebugUI.js.map